import AclName from '../acl/AclName';

export default [
  {
    path: '/my-agreements',
    name: 'my-agreements',
    components: {
      default: () => import('../views/pages/my_agreements/MyAgreementsList.vue'),
    },
    meta: {
      acl: AclName.CrmPageMyAgreementsList,
      breadcrumb: [
        { title: 'Moje umowy', url: '/my-agreements' },
      ],
    },
  },
  {
    path: '/my-agreements/:id/sign',
    name: 'my-agreements-sign',
    components: {
      default: () => import('../views/pages/my_agreements/my-agreement-sign.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Moje umowy', url: '/my-agreements' },
      ],
      rule: 'editor',
      serach: false,
      module: 'CRM',
    },
  },
  {
    path: '/my-agreements/:id(\\d+)/review',
    name: 'my-agreements-review',
    component: () => import('../views/pages/my_agreements/my-agreement-review.vue'),
    meta: {
      acl: AclName.CrmPageAgreementReview,
      breadcrumb: [
        { title: 'Moje umowy', url: '/my-agreements' },
      ],
    },
  },
];
